module.exports = __webpack_public_path__ + "img/1.520ef7f.png";